import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import { Button, Card, CardBody, CardTitle, Col, Container, Form, Label, Row } from 'reactstrap'
import * as Yup from 'yup'
import Breadcrumbs from '../../components/Common/Breadcrumb'
import Select from 'react-select';
import { addRoleDataAccess, getRoleDataAccessById, getRoleDataAccessOptions, updateRoleDataAccess } from 'helpers/UAM/roleDataAccess.helper';
import ToastDialog from 'common/ToastDialog';
import { useNavigate, useParams } from 'react-router-dom';
import { isEmpty } from 'lodash';
const AddOrEditRoleDataAccess = () => {

  let title = "Add | Role based data access";
  const { roleName } = JSON.parse(localStorage.getItem("user"))
  const navigate = useNavigate();
  const { id } = useParams();
  const decodeId = !isEmpty(id) ? atob(id) : null;

  if (!isEmpty(id)) {
    title = "Edit | Role based data access";
  }
  const [roleOptions, setRoleOptions] = useState([]);
  const [dataAccessOptions, setDataAccessOptions] = useState([]);
  const [toastInfo, setToastInfo] = useState({
    showToast: false,
    message: "",
    role: "",
  });


  const getOptionsToSelect = async () => {
    const apiRes = await getRoleDataAccessOptions();
    if (apiRes.status) {
      const { roles, dataAccess } = apiRes.data;
      const roleOptions = roles.map((role) => {
        return { value: role['id'], label: role['display_name'] };
      });

      const dataAccessOptions = dataAccess.map((dataAccess) => {
        return { value: dataAccess['id'], label: dataAccess['name'] };
      });

      setRoleOptions(roleOptions);
      setDataAccessOptions(dataAccessOptions);
    } else {
      setToastInfo({
        showToast: true,
        message: apiRes.message,
        role: "error",
      });
    }
  }

  const getRoleDataAccess = async (id) => {
    const apiRes = await getRoleDataAccessById({ id });
    if (apiRes.status) {
      const { data } = apiRes;
      formik.setFieldValue("roleId", data.roleId);
      formik.setFieldValue("dataAccessId", data.dataAccessId);
    } else {
      setToastInfo({
        showToast: true,
        message: apiRes.message,
        role: "error",
      });
    }
  }


  useEffect(() => {
    getOptionsToSelect();
  }, []);

  useEffect(() => {
    if (id) {
      getRoleDataAccess(decodeId);
    }
  }, [id]);


  const handleFormSubmit = async (values) => {
    const bodyData = {
      ...values
    }
    if (!isEmpty(id)) {
      bodyData['id'] = decodeId;
    }
    const apiRes = !isEmpty(id) ? await updateRoleDataAccess(bodyData) : await addRoleDataAccess(bodyData);
    if (apiRes.status) {
      navigate(`/${roleName}/role-data-access`);
      setToastInfo({
        showToast: true,
        message: apiRes.message,
        role: "success",
      });
    } else {
      setToastInfo({
        showToast: true,
        message: apiRes.message,
        role: "error",
      });
    }
  }

  const handleGoBack = () => {
    navigate(`/${roleName}/role-data-access`);
  }

  const formik = useFormik({
    initialValues: {
      roleId: "",
      dataAccessId: "",
    },
    validationSchema: Yup.object({
      roleId: Yup.string().required('Required'),
      dataAccessId: Yup.string().required('Required'),
    }),
    onSubmit: async (values) => {
      handleFormSubmit(values);
    },
  });




  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Dealer" breadcrumbItem={title} />
          <Row>
            <Col xl={12}>
              <Card>
                <CardBody>
                  <CardTitle className="mb-4">New Data Access</CardTitle>
                  <Form onSubmit={formik.handleSubmit} >
                    <Row className="mb-4">

                      <Col lg={6} className="mb-3">
                        <Label htmlFor="roleId">Role
                        <span className="text-danger">*</span>
                        </Label>
                        <Select 
                          id="roleId"
                          name="roleId"
                          classNamePrefix="select2-selection"
                          options={roleOptions}
                          onChange={(option) => {
                            formik.setFieldValue("roleId", option.value);
                          }}
                          value={
                            roleOptions.find(
                              (option) => option.value == formik.values.roleId
                            ) || ""
                          }
                          
                        />
                        {formik.touched.roleId && formik.errors.roleId && (
                          <span className="text-danger">{formik.errors.roleId}</span>
                        )}
                      </Col>

                      <Col lg={6} className="mb-3">
                        <Label htmlFor="dataAccessId">Data Access  
                          <span className="text-danger">*</span>
                        </Label>
                        <Select 
                          id="dataAccessId"
                          name="dataAccessId"
                          classNamePrefix="select2-selection"
                          options={dataAccessOptions}
                          onChange={(option) => {
                            formik.setFieldValue("dataAccessId", option.value);
                          }}
                          value={
                            dataAccessOptions.find(
                              (option) => option.value == formik.values.dataAccessId
                            ) || ""
                          }
                        />
                        {formik.touched.dataAccessId && formik.errors.dataAccessId && (
                          <span className="text-danger">{formik.errors.dataAccessId}</span>
                        )}
                      </Col>

                      <Col lg={12} className="mt-4 d-flex align-items-center justify-content-end">
                        <Button type="button" onClick={handleGoBack} outline color=" btn btn-outline-secondary" className="w-md me-2">Cancel</Button>
                        <Button type="submit" color="success" className="w-md">
                          {isEmpty(id) ? "Save" : "Update"}
                        </Button>
                      </Col>

                    </Row>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {toastInfo.showToast && <ToastDialog 
        showToast={toastInfo.showToast}
        message={toastInfo.message}
        role={toastInfo.role}
        onCloseFn={() => setToastInfo({})}
      />}
    </React.Fragment>
  )
}

export default AddOrEditRoleDataAccess